/* dts-atas-template — shared horizontal carousel + countdown */
if (!customElements.get('dts-carousel')) {
  class DtsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dts-track]');
      if (!this.track) return;
      this.prevBtns = this.querySelectorAll('[data-dts-prev]');
      this.nextBtns = this.querySelectorAll('[data-dts-next]');
      const id = this.getAttribute('data-controls-from');
      if (id) {
        const ext = document.getElementById(id);
        if (ext) {
          this.prevBtns = [...this.prevBtns, ...ext.querySelectorAll('[data-dts-prev]')];
          this.nextBtns = [...this.nextBtns, ...ext.querySelectorAll('[data-dts-next]')];
        }
      }
      const step = () => {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const w = card.getBoundingClientRect().width;
        return w * Math.max(1, Math.round(this.track.clientWidth / w) - 1 || 1);
      };
      this.prevBtns.forEach((b) => b.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' })));
      this.nextBtns.forEach((b) => b.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' })));
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.addEventListener('shopify:block:select', (e) => {
        const el = e.target.closest('[data-dts-track] > *');
        if (el) this.track.scrollTo({ left: el.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      });
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prevBtns.forEach((b) => (b.disabled = this.track.scrollLeft <= 2));
      this.nextBtns.forEach((b) => (b.disabled = this.track.scrollLeft >= max));
    }
  }
  customElements.define('dts-carousel', DtsCarousel);
}

if (!customElements.get('dts-countdown')) {
  class DtsCountdown extends HTMLElement {
    connectedCallback() {
      const ts = parseInt(this.getAttribute('data-end-ts'), 10);
      const raw = this.getAttribute('data-end') || '';
      this.end = !isNaN(ts) && ts > 0 ? ts * 1000 : Date.parse(raw.replace(' ', 'T'));
      if (isNaN(this.end)) { this.hidden = true; return; }
      this.parts = {
        d: this.querySelector('[data-d]'),
        h: this.querySelector('[data-h]'),
        m: this.querySelector('[data-m]'),
        s: this.querySelector('[data-s]'),
      };
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      let diff = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (diff === 0) {
        clearInterval(this.timer);
        this.classList.add('is-ended');
      }
      const d = Math.floor(diff / 86400); diff -= d * 86400;
      const h = Math.floor(diff / 3600); diff -= h * 3600;
      const m = Math.floor(diff / 60); const s = diff - m * 60;
      const pad = (n) => String(n).padStart(2, '0');
      if (this.parts.d) this.parts.d.textContent = d;
      if (this.parts.h) this.parts.h.textContent = pad(h);
      if (this.parts.m) this.parts.m.textContent = pad(m);
      if (this.parts.s) this.parts.s.textContent = pad(s);
    }
  }
  customElements.define('dts-countdown', DtsCountdown);
}
